import { ActionOnFieldHandler } from './ActionOnFieldHandler';

export class RouteToActionHandler extends ActionOnFieldHandler {
  constructor() {
    super('routeTo');
  }

  handleAction(actionPolicy: any, data: any): Promise<void> {
    if (this.canHandleAction(actionPolicy)) {
      data.routeTo();
    }
    return Promise.resolve();
  }
}
